import React, { useEffect, useState } from "react"
import { Button, Form, Input, Modal, Row, Select, Upload } from "antd"
import { PreviewImgOrPdf } from "../filingManagement/Preview"
import {
  acceptImgTypes,
  AXIOS_IP_WATER,
  beforeUpload,
  beforeUploadALL,
  beforeUploadFile,
  customRequest,
} from "../filingManagement/fileUploadService"
import { CloseOutlined, PlusOutlined } from "@ant-design/icons"

export const UploadFormItem = (props: {
  label: string
  name: string
  required: boolean
  token: string
  type?: number //文件类型
  template?: any //模板数据
  maxCount?: number
  rules?: any[]
  defaultValue?: any // 编辑的默认数据
  changeForm?: (v: any) => void
}) => {
  const [fileList, setFileList] = useState<any>(props.defaultValue || [])

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const allType = ".pdf,.png,.tiff,.jpg,.jpeg,bmp,.webp"

  //参考模板
  const templateData = {
    fileConfigId: "5",
    fileName: "参考模板",
    fileType: "application/pdf",
    filePath:
      "68e0cfd54adf77575a83a2b739bf5ddfa207356d866e9e74b8236c4b070475f8",
  }
  // 自定义上传实现
  const customRequestFn = (options: any, type: string) => {
    customRequest(options, AXIOS_IP_WATER, (data: any) => {
      const newurl = {
        fileConfigId: data?.configId,
        fileName: data?.name,
        fileType: data?.type,
        filePath: data?.path,
      }
      switch (type) {
        case "DJ":
          setFileList([...fileList, newurl])
          break
      }
    })
  }

  const handleRemove = (type: string, index: number) => {
    switch (type) {
      case "DJ":
        setFileList(fileList?.filter((v: any, i: number) => i !== index))
        break
    }
  }

  useEffect(() => {
    setFileList(props.defaultValue || [])
  }, [props.defaultValue])

  useEffect(() => {
    props.changeForm && props.changeForm(fileList)
  }, [fileList])

  return (
    <>
      <Form.Item
        label={props.label}
        name={props.name}
        rules={[{ required: props.required, ...props.rules, message: `请上传${props.label}` }]}
      >
        <Row align="middle">
          <Upload
            customRequest={(options) => customRequestFn(options, "DJ")}
            beforeUpload={(file) =>
              props.type == 1
                ? beforeUploadFile(file, fileList, props.maxCount)
                : props.type == 2
                ? beforeUploadALL(file, fileList, props.maxCount)
                : beforeUpload(file, fileList, props.maxCount)
            }
            showUploadList={false}
            maxCount={props.maxCount || 3}
            accept={
              props.type == 1
                ? ".pdf"
                : props.type == 2
                ? allType
                : acceptImgTypes
            }
          >
            <Button icon={<PlusOutlined />}>{props.type == 3 ? '上传图片' : '上传附件'}</Button>
          </Upload>
          <span style={{ padding: "0 10px 0 15px" }}>
            {props.type == 1
              ? "支持pdf等文件格式"
              : props.type == 2
              ? "支持pdf和图片格式"
              : ""}
          </span>
          {props.template && (
            <a
              style={{ textDecoration: "underline", paddingRight: 10 }}
              onClick={() => setPreviewFile(templateData)}
            >
              参考模板
            </a>
          )}
          {fileList?.length > 0 &&
            fileList?.map((v: any, index: number) => {
              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    paddingRight: 10,
                  }}
                >
                  <span style={{ paddingRight: 10 }}>
                    {v.fileName}{" "}
                    <a
                      style={{ paddingLeft: 10 }}
                      onClick={() => setPreviewFile(v)}
                    >
                      查看
                    </a>
                  </span>
                  <CloseOutlined
                    style={{
                      position: "relative",
                      top: 2,
                      color: "rgb(161 161 161)",
                    }}
                    onClick={() => {
                      handleRemove("DJ", index)
                    }}
                  />
                </div>
              )
            })}
        </Row>
      </Form.Item>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP_WATER}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
